import React from 'react'
import { useParams } from 'react-router-dom'
import styles from './GeoHeader.module.scss'
import Content from '../../../components/Content'

import Layout from '../../../components/Layout'
import GeoProvider from '../../../components/GeoProvider'
import DashboardMap from './DashboardMap'
import dataDisplayOptions from '../dataDisplayOptions'
import { startDate, endDate } from '../dates'
import Header from './Header'
import SystemNotification from '../../Dashboard/SystemNotification'
import ModelTabs from './ModelTabs'
import categoryDisplayOptions from '../categoryDisplayOptions'
const BirthTrendCountyDashboard = () => {
   if(window.localStorage.getItem('bt_category')===null)
    {window.localStorage.setItem('bt_category',categoryDisplayOptions[0].value)}
  const { geo_parent, area, loc } = useParams()

  return (
    <Layout>
      <Content>
        <div className={styles.base}>
          <div className={styles.body}>
            <GeoProvider
              startDate={startDate}
              endDate={endDate}
              isChecked={false}
              displayDate={"2025-01-01"}
              locationName={loc}
              mapOptions={dataDisplayOptions[0]['options'][0]}
              indicatorName={dataDisplayOptions[0]['options'][0].indicatorName}
              regionSelected={'fips'}
            >
              <SystemNotification/>
              <Header headerType={geo_parent}  geo_id={loc} />
              <ModelTabs  geo_type={area}
                geo_parent={geo_parent}
                zoomLocation={loc}>
                
              </ModelTabs>
            
             
            </GeoProvider>
          </div>
        </div>
      </Content>
    </Layout>
  )
}

export default BirthTrendCountyDashboard
